// Bundled with webpack
// import $ from 'jquery';

// Not seeing this being used anywhere in the project
// import 'Lib/jquery.onmutate';
import whenDomReady from 'when-dom-ready';

/*
 * !!!!!!!!!!
 * Do not use regular ES6 imports in this file!
 * In order to speed up page load, use webpack's dynamic import:
 * https://webpack.js.org/guides/code-splitting/#dynamic-imports
 *
 * This allows the subsequent modules to be loaded when-needed and chunked
 * on a per-page basis.
 *
 * Importing everything at the top of the file leads to all of these modules
 * being loaded on every page in one giant bundle.
 *
 */
/*
import ViewUGC from 'Views/view-ugc';
import CartView from 'Views/view-cart';
import PassesView from 'Views/view-passes';
import KidsPassesView from 'Views/view-kids-passes';
import CampCretaceousView from 'Views/view-camp-cretaceous';
import EnhancedPLPView from 'Views/view-enhanced-plp';
import FitAppView from 'Views/view-fitapp';
import TrailChampionshipView from 'Views/view-trail-championship';
//import EnhancedCollectionView from 'Views/view-enhanced-collection';
import FlexibleLPView from 'Views/view-flexible-lp';
//import StaticPage from 'Views/StaticPage';
*/
// if (!process.env.NODE_ENV !== 'production') {
//     // Debug scroll weirdness, remove at some point
//     const _animate = $.fn.animate;
//     $.fn.animate = function (properties, duration, easing) {
//         if (properties.scrollTop) {
//             debugger;
//         }
//
//         _animate.call(this, properties, duration, easing);
//     };
// }
export default class Router {
    constructor() {
        whenDomReady(async () => {
            console.log('Body created, routing...', $);

            if (process.env.NODE_ENV !== 'production') {
                // Logs all calls to preventDefault / stopPropagation in an user-friendly way
                const logEventMethodCall = (event, methodName) => {
                    const MinimumMeaninfulSelectors = 3; // how much meaningful items we want in log message
                    const target = event.target;

                    const selector = (function computeSelector() {
                        const parentSelectors = [];
                        let node = target;
                        let minimumSelectors = 0;
                        do {
                            const meaningfulSelector = node.id
                                ? `#${node.id}`
                                : node.classList.length > 0
                                ? `.${Array.prototype.join.call(
                                      node.classList,
                                      '.'
                                  )}`
                                : undefined;
                            if (meaningfulSelector) minimumSelectors++;
                            const nodeSelector = `${node.tagName.toLowerCase()}${
                                meaningfulSelector ? meaningfulSelector : ''
                            }`;
                            parentSelectors.unshift(nodeSelector);
                            node = node.parentNode;
                        } while (
                            node &&
                            node !== document &&
                            minimumSelectors < MinimumMeaninfulSelectors
                        );
                        return parentSelectors.join(' > ');
                    })();

                    console.debug(
                        `${event.type}.${methodName}() on ${selector}`,
                        event
                    );
                };

                const oldEPD = Event.prototype.preventDefault;
                Event.prototype.preventDefault = function () {
                    logEventMethodCall(this, 'preventDefault');
                    oldEPD.call(this);
                };
            }

            const $body = $('body');
            const bodyClass = $body.attr('class');
            const tempSuffix = $body.data('tempsuffix') ?? '';

            if ($body.hasClass('template-checkout') === false) {
                console.log('LOAD GLOBAL VIEW');
                const { default: GlobalView } = await import('Views/Global');
                ORW.GlobalView = new GlobalView();
                await ORW.GlobalView.init();

                const { default: ViewUGC } = await import('Views/Ugc');
                new ViewUGC({ $el: $body });
            } else {
                const { default: CheckoutView } = await import(
                    'Views/Checkout'
                );

                new CheckoutView();
            }

            if ($body.hasClass('template-index')) {
                const { default: ViewHome } = await import('Views/Home');
                new ViewHome({ $el: $('#MainContent') });
            }

            if ($body.hasClass('template-product')) {
                const { default: ViewProduct } = await import('Views/Product');
                new ViewProduct({ $el: $('.product-detail-container') });
            }

            if (
                ($body.hasClass('template-collection') ||
                    $body.hasClass('template-search')) &&
                $body.data('tempsuffix') != 'lookbook'
            ) {
                const { default: CollectionView } = await import(
                    'Views/Collection'
                );
                const { default: EnhancedCollectionView } = await import(
                    'Views/EnhancedCollection'
                );
                new CollectionView({ $el: $('.product-collection') });
                new EnhancedCollectionView();
            }

            if ($body.hasClass('template-giftcard')) {
                const { default: GiftCardView } = await import(
                    'Views/Giftcard'
                );

                GiftCardView();
            }

            if (
                $body.hasClass('template-blog') ||
                $body.data('tempsuffix') === 'unbreakable' ||
                $body.data('tempsuffix') === 'training'
            ) {
                const { default: BlogView } = await import('Views/Blog');
                new BlogView({ $el: $('#MainContent') });
            }

            // if ($body.hasClass('template-suffix-webpack')) {
            //     require('Pages/page-webpack');
            // }

            if ($body.hasClass('template-suffix-styles')) {
                const { default: ViewStyleGuide } = await import(
                    'Views/StyleGuide'
                );
                new ViewStyleGuide({ $el: $('.style-guide-wrapper') });
            }

            if ($body.data('tempsuffix') == 'about') {
                const { default: AboutView } = await import('Views/About');
                new AboutView({ $el: $('#MainContent') });
            }

            if ($body.hasClass('template-suffix-utility')) {
                const { default: UtilityView } = await import('Views/Utility');
                new UtilityView({ $el: $('#MainContent') });
            }

            if (
                $body.hasClass('page-account') ||
                $body.hasClass('page-create-account') ||
                $body.hasClass('page-reset-account') ||
                $body.hasClass('page-addresses') /*||
                $body.hasClass('template-customers-order')*/
            ) {
                const { default: AccountView } = await import('Views/Account');
                AccountView();
            }

            if ($body.hasClass('template-article')) {
                const { default: ArticleView } = await import('Views/Article');
                new ArticleView({ $el: $('#MainContent') });
            }

            if ($body.hasClass('page-your-shopping-cart')) {
                const { default: CartView } = await import('Views/Cart');
                CartView();
            }

            if ($body.hasClass('template-suffix-brand-landing')) {
                const { default: BrandLandingView } = await import(
                    'Views/BrandLanding'
                );
                new BrandLandingView();
            }

            if ($body.hasClass('template-suffix-membership')) {
                const { default: MembershipView } = await import(
                    'Views/Membership'
                );
                new MembershipView();
            }

            if (
                $body.hasClass('template-suffix-pass') ||
                $body.hasClass('template-suffix-trail-pass') ||
                $body.hasClass('template-suffix-laborday') ||
                $body.hasClass('template-suffix-trifecta')
            ) {
                const { default: PassesView } = await import('Views/Passes');
                new PassesView();
            }

            if ($body.hasClass('template-suffix-kids-pass')) {
                const { default: KidsPassesView } = await import(
                    'Views/KidsPasses'
                );
                new KidsPassesView();
            }

            if ($body.hasClass('template-suffix-camp-cretaceous')) {
                const { default: CampCretaceousView } = await import(
                    'Views/CampCretaceous'
                );
                new CampCretaceousView();
            }

            if (bodyClass.includes('template-suffix-enhanced-plp')) {
                const { default: EnhancedPLPView } = await import(
                    'Views/EnhancedPLP'
                );
                new EnhancedPLPView();
            }

            if ($body.hasClass('template-suffix-trail-world-champ')) {
                const { default: TrailChampionshipView } = await import(
                    'Views/TrailChampionship'
                );
                new TrailChampionshipView();
            }

            if ($body.hasClass('template-suffix-fitapp')) {
                const { default: FitAppView } = await import('Views/FitApp');
                new FitAppView();
            }

            if ($body.hasClass('template-suffix-flexible-sale-lp')) {
                const { default: FlexibleLPView } = await import(
                    'Views/FlexibleLP'
                );
                new FlexibleLPView();
            }

            if (
                tempSuffix.includes('joes-book') ||
                tempSuffix.includes('new-user-lp') ||
                tempSuffix.includes('teams')
            ) {
                const { default: StaticPageView } = await import(
                    'Views/StaticPage'
                );
                new StaticPageView();
            }
        });
    }
}
